import { Flex, Text } from '@chakra-ui/react'
import { Building } from '../../icons'


export const Address = ({ postCode, street, streetNumber, city }: { postCode?: string, street?: string, streetNumber?: string, city?: string }) => {
  return postCode || street || streetNumber || city ?
    <Flex my={1} sx={{ gap: 2, flexWrap: 'wrap' }}>
      <Building color="secondary.500" />
      {street} {streetNumber}, {postCode} {city}
    </Flex>
    :
    <Text sx={{ color: 'gray.500' }}>Adresa není k dispozici</Text>
}